/**
 * Notification group/subject
 */
export enum NotificationKindEnum {
  TASK = 'TASK',
  DEAL = 'DEAL',
  VARIANCE = 'VARIANCE',
  PROJECT = 'PROJECT',
  HELPDESK = 'HELPDESK',
  PERSONAL = 'PERSONAL',
  MAILING = 'MAILING',
  PURCHASE = 'PURCHASE',
}
